import React from 'react';
import * as R from 'ramda';
import { useSelector } from 'react-redux';
import { FormattedMessage } from '../i18n';
import { getHasNoTime } from '../selectors/chart';
import useSdmxData from './useSdmxData';
import { getData } from '../selectors/sdmx';
import { getDuplicatedObservations } from '../selectors/data';
import useSdmxStructure from './useSdmxStructure';
import useGetUsedFilters from './useGetUsedFilters';
import useSdmxDataTime from './sdmx/useSdmxDataTime';

export default () => {
  const { hasTime } = useSdmxDataTime();
  const hasNoTimeForChart = useSelector(getHasNoTime);
  const { isError, error } = useSdmxData();
  const data = useSelector(getData);
  const observations = useSelector(getDuplicatedObservations);
  const noObservations = R.isEmpty(observations) && !R.isNil(data);
  const { observationsCount, actualConstraints } = useSdmxStructure();
  const selection = useGetUsedFilters();

  let noData = null;
  let errorMessage = null;
  if (isError || noObservations) {
    const status = error?.response?.status;
    if (status === 404 || noObservations) {
      if (observationsCount == 0 || R.isEmpty(actualConstraints))
        errorMessage = <FormattedMessage id="vx.no.data" />;
      else errorMessage = <FormattedMessage id="vx.no.data.selection" />;
    } else if (R.includes(status, [401, 402, 403]))
      errorMessage = <FormattedMessage id="log.error.sdmx.40x" />;
    else errorMessage = <FormattedMessage id="log.error.sdmx.xxx" />;
  } else {
    if (hasNoTimeForChart)
      errorMessage = <FormattedMessage id="vx.no.time.data" />;
    if (!hasTime) errorMessage = <FormattedMessage id="vx.no.data.selection" />;
    if (!R.isEmpty(selection))
      noData = <FormattedMessage id="vx.no.data.selection" />;
  }

  return { noData, errorMessage };
};
